import { PencilSquareIcon, CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";

function InfoRow({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex flex-wrap justify-between gap-x-4 gap-y-1">
      <span className="text-gray-600 shrink-0">{label}</span>
      <span className="font-medium text-gray-900 text-right min-w-0 sm:min-w-[140px] break-words">
        {children}
      </span>
    </div>
  );
}

function InfoBox({
  title,
  editing,
  onEdit,
  onCancel,
  onSave,
  children,
}: {
  title?: string;
  editing: boolean;
  onEdit: () => void;
  onCancel: () => void;
  onSave: () => void;
  children: React.ReactNode;
}) {
  return (
    <div className="rounded-lg border border-gray-200 bg-gray-50 p-3 space-y-2 text-sm">
      <div className="flex items-center justify-between">
        {title ? (
          <div className="text-sm font-semibold text-gray-700">{title}</div>
        ) : (
          <div />
        )}

        {!editing ? (
          <button
            type="button"
            onClick={onEdit}
            className="inline-flex items-center gap-1 text-xs font-medium text-primary-700 hover:text-primary-800"
          >
            <PencilSquareIcon className="h-4 w-4" />
            Edit
          </button>
        ) : (
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={onCancel}
              className="inline-flex items-center gap-1 text-sm font-medium text-gray-600 hover:text-gray-800"
            >
              <XMarkIcon className="h-4 w-4" />
              Cancel
            </button>
            <button
              type="button"
              onClick={onSave}
              className="inline-flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-800"
            >
              <CheckIcon className="h-4 w-4" />
              Save
            </button>
          </div>
        )}
      </div>

      {children}
    </div>
  );
}

export {
  InfoBox,
  InfoRow,
}